import React from 'react'
import styled, { css } from 'styled-components'
import { BlockTypeEnum, PaperBlock } from 'packages/sdks-next/growp'
import { RichTextRenderer } from 'packages/components/RichText'
import { QuestionBlock } from './QuestionBlock'

export const Block: React.FC<{
  block: PaperBlock
}> = ({ block }) => {
  const { type } = block || {}
  switch (type) {
    case BlockTypeEnum.Question: {
      return (
        <Wrapper>
          <QuestionBlock block={block} />
        </Wrapper>
      )
    }
    case BlockTypeEnum.Fulltext: {
      return (
        <Wrapper>
          <RichTextRenderer value={block.content || ''} />
        </Wrapper>
      )
    }
    default: {
      return (
        <Wrapper>
          <HeaderWrapper $type={type}>{block.content}</HeaderWrapper>
        </Wrapper>
      )
    }
  }
}

const Wrapper = styled.div`
  width: 100%;
  padding: 8px 16px;
  border-radius: 8px;
`

const HeaderWrapper = styled.div<{ $type: BlockTypeEnum }>`
  color: ${(props) => props.theme.text._1};
  ${({ $type }) =>
    $type === BlockTypeEnum.FirstLevelTitle
      ? css`
          font-size: 24px;
          line-height: 33.6px;
        `
      : $type === BlockTypeEnum.SecondLevelTitle
      ? css`
          font-size: 20px;
          line-height: 30px;
        `
      : $type === BlockTypeEnum.ThirdLevelTitle
      ? css`
          font-size: 18px;
          line-height: 28px;
        `
      : $type === BlockTypeEnum.FourthLevelTitle
      ? css`
          font-size: 16px;
          line-height: 24px;
        `
      : null};
`
